import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

const login = () => import('@/views/pages/login.vue')
const reset = () => import('@/views/pages/reset.vue')

const loginEntrance = () => import('@/views/pages/loginEntrance.vue')
const dashboard = () => import('@/views/module/dashboard/dashboard.vue')
const DefaultContainer = () => import('@/core/container/DefaultContainer.vue')
const SubDefaultContainer = () => import('@/core/container/sub/SubDefaultContainer.vue')
// 学习班类型
const StudyClassType = () => import('@/views/module/studyclasstype/studyclasstype.vue')
const StudyClassTypeAdd = () => import('@/views/module/studyclasstype/studyclasstypeadd.vue')
const StudyClassTypeEdit = () => import('@/views/module/studyclasstype/studyclasstypeedit.vue')
const studyclasstypelocation = () => import('@/views/module/studyclasstype/studyclasstypelocation.vue')

// 开班单位
const Classunit = () => import('@/views/module/classunit/classunit.vue')
const ClassunitAdd = () => import('@/views/module/classunit/classunitadd.vue')
const ClassunitEdit = () => import('@/views/module/classunit/classunitedit.vue')

// 学习班
const StudyClass = () => import('@/views/module/studyclass/studyclass.vue')
const StudyClassAdd = () => import('@/views/module/studyclass/studyclassadd.vue')
const StudyClassEdit = () => import('@/views/module/studyclass/studyclassedit.vue')

// 课程
const Course = () => import('@/views/module/course/course.vue')
const CourseAdd = () => import('@/views/module/course/courseadd.vue')
const CourseEdit = () => import('@/views/module/course/courseEdit.vue')

// 开始排课
const schedulingStart = () => import('@/views/module/start/schedulingStart.vue')
// 排课列表
const scheduling = () => import('@/views/module/start/scheduling.vue')
const schedulingEdit = () => import('@/views/module/start/schedulingEdit.vue')

// 后台用户
const muserList = () => import('@/views/module/muser/muser.vue')
const muserAdd = () => import('@/views/module/muser/museradd.vue')
const muserEdit = () => import('@/views/module/muser/museredit.vue')

const roleList = () => import('@/views/module/role/role.vue')
const roleEdit = () => import('@/views/module/role/roleEdit.vue')
// 党组织
const partyOrganization = () => import('@/views/module/partyOrganization/partyOrganization.vue')
const partyOrganizationAdd = () => import('@/views/module/partyOrganization/partyOrganizationAdd.vue')
const partyOrganizationEdit = () => import('@/views/module/partyOrganization/partyOrganizationEdit.vue')
// 学员管理
const user = () => import('@/views/module/user/user.vue')
const userAdd = () => import('@/views/module/user/useradd.vue')
const userEdit = () => import('@/views/module/user/useredit.vue')

// 学习班
const studyclassHours = () => import('@/views/module/studyclass/studyclassHours.vue')
const studyclassHoursDetail = () => import('@/views/module/studyclass/studyclassHoursDetail.vue')
const classPlanDetail = () => import('@/views/module/studyclass/classPlanDetail.vue')
// 请假审核
const leaveExamine = () => import('@/views/module/leaveExamine/leaveExamine.vue')
const leaveHandle = () => import('@/views/module/leaveExamine/leaveHandle.vue')
const leaveDetail = () => import('@/views/module/leaveExamine/leaveDetail.vue')


// 补签
const fillCheck = () => import("@/views/module/fillcheck/fillcheck.vue");
const fillCheckDetail = () => import("@/views/module/fillcheck/fillcheckdetail.vue");
const fillCheckAll = () => import("@/views/module/fillcheck/fillcheckall.vue");
const fillCheckApply = () => import("@/views/module/fillcheck/fillcheckapply.vue");


// 学时信息
// 学员
const userClassHours = () => import('@/views/module/user/userClassHours.vue')

const userClassHoursDetail = () => import('@/views/module/user/classHoursDetail.vue')

const exportQuick = () => import('@/views/module/export/exportQuick.vue')

// 报表管理
const ExportClassunit = () => import('@/views/module/export/classunit/ExportClassunit.vue')
const ExportClassunitDetail = () => import('@/views/module/export/classunit/ExportClassunitDetail.vue')

const ExportPartyOrg = () => import('@/views/module/export/partyorg/ExportPartyorg.vue')
const ExportPartyorgDetail = () => import('@/views/module/export/partyorg/ExportPartyorgDetail.vue')

const SchedulingHours = () => import('@/views/module/export/scheduling/SchedulingHours.vue')

const FXUser = () => import('@/views/module/fxuser/fxuser.vue')

// 补充学时
const SupplementScore = () =>import('@/views/module/supplementscore/SupplementScore.vue')


// 编辑个人资料
const editProfile = () => import('@/views/module/editProfile/editProfile.vue')


Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: '首页',
    redirect: '/dashboard',
    component: DefaultContainer,
    children: [
      {
        path: 'dashboard',
        name: '首页概览',
        component: dashboard
      },
      {
        path: '/editProfile',
        name: '编辑个人资料',
        component: editProfile,
      },

      // 课程
      {
        path: 'course',
        name: '课程',
        redirect: '/course/dashboard',
        component: SubDefaultContainer,
        children: [
          {
            path: 'dashboard',
            name: '课程概览',
            component: Course
          },
          {
            path: 'add',
            name: '增加课程',
            component: CourseAdd
          },
          {
            path: 'edit',
            name: '修改课程',
            component: CourseEdit
          }
        ]
      },

      // 学习班
      {
        path: 'studyclass',
        name: '学习班',
        redirect: '/studyclass/dashboard',
        component: SubDefaultContainer,
        children: [
          {
            path: 'dashboard',
            name: '学习班概览',
            component: StudyClass

          },
          {
            path: 'add',
            name: '增加学习班',
            component: StudyClassAdd,
            meta: { api: "https://www.yuque.com/u314548/ua2qh6/mnfnv5" }
          },
          {
            path: 'edit',
            name: '修改学习班',
            component: StudyClassEdit
          }
        ]
      },

      // 学时管理
      {      
          path: 'score',
          name: '学时管理',
          redirect: '/score/supplement',
          component: SubDefaultContainer,
          children:[
            {
              path: 'supplement',
              name: '补充学时',
              component: SupplementScore
            }
          ]      
      },

      // 基础数据
      {
        path: 'standard',
        name: '基础数据',
        redirect: '/standard/studyclasstype',
        component: SubDefaultContainer,
        children: [
          // 学习班类型
          {
            path: 'studyclasstype',
            name: '学习班类型',
            component: SubDefaultContainer,
            redirect: 'studyclasstype/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '学习班类型概览',
                component: StudyClassType
              },
              {
                path: 'add',
                name: '增加学习班类型',
                component: StudyClassTypeAdd
              },
              {
                path: 'edit',
                name: '修改学习班类型',
                component: StudyClassTypeEdit
              },
              {
                path: 'location',
                name: '修改显示位置',
                component: studyclasstypelocation
              }

            ]
          },
          // 开班单位
          {
            path: 'classunit',
            name: '单位',
            component: SubDefaultContainer,
            redirect: 'classunit/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '单位概览',
                component: Classunit
              },
              {
                path: 'add',
                name: '增加单位',
                component: ClassunitAdd
              },
              {
                path: 'edit',
                name: '修改单位',
                component: ClassunitEdit
              }
            ]
          },
          // 党组织
          {
            path: 'partyorg',
            name: '党组织',
            component: SubDefaultContainer,
            redirect: 'partyorg/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '党组织概览',
                component: partyOrganization
              },
              {
                path: 'add',
                name: '增加党组织',
                component: partyOrganizationAdd
              },
              {
                path: 'edit',
                name: '修改党组织',
                component: partyOrganizationEdit
              }
            ]
          },

          // 复兴一号
          {
            path: 'fxuser',
            name: '复兴一号（学员）',
            component: SubDefaultContainer,
            redirect: 'fxuser/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '复兴一号（学员） 概览',
                component: FXUser
              }
            ]
          }
        ]
      },

      // 系统全局管理
      {
        // 账号
        path: 'standard',
        name: '系统管理',
        component: SubDefaultContainer,
        redirect: '/standard/muser',
        children: [
          {
            path: 'muser',
            name: '后台用户',
            component: SubDefaultContainer,
            redirect: 'muser/muserList',
            children: [
              {
                path: 'muserList',
                name: '后台用户概览',
                component: muserList
              },
              {
                path: 'add',
                name: '增加后台用户',
                component: muserAdd,
                meta: { api: "https://www.yuque.com/u314548/ua2qh6/kt89x3" }

              },
              {
                path: 'edit',
                name: '修改后台用户',
                component: muserEdit,
                meta: { api: "https://www.yuque.com/u314548/ua2qh6/kt89x3" }

              },
            ]
          },
          {
            path: 'role',
            name: "权限",
            component: SubDefaultContainer,
            redirect: 'role/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '权限概览',
                component: roleList
              },
              {
                path: 'edit',
                name: '修改权限',
                component: roleEdit
              }
            ]
          }

        ]

      },

      // 排课管理
      {
        path: 'standard/scheduling',
        name: '排课管理',
        component: SubDefaultContainer,
        redirect: 'standard/scheduling/scheduling',
        children: [
          {
            path: 'scheduling',
            name: '概览',
            component: scheduling

          },
          {
            path: 'edit',
            name: '修改排课',
            component: schedulingEdit,
            meta: { api: "https://www.yuque.com/u314548/ua2qh6/fgsgkl" }
          }
        ]
      },

      // 补签审核
      {
          path: 'fillcheck',
          name: '补签审核',
          component: SubDefaultContainer,
          redirect: 'fillcheck/dashboard',
          children: [
            {
              path: 'dashboard',
              name: '补签审核概览',
              component: fillCheck
            },
            {
              path: 'detail',
              name: '补签',
              component: fillCheckDetail
            },
            {
              path: 'all',
              name: '补签详细信息',
              component: fillCheckAll
            },
            {
              path: 'apply',
              name: '补签审核列表信息',
              component: fillCheckApply
            },
          ]
      },

        // 请假审核
        {
          path: 'leave',
          name: '请假审核',
          component: SubDefaultContainer,
          redirect: 'leave/dashboard',
          children: [
            {
              path: 'dashboard',
              name: '请假审核概览',
              component: leaveExamine,
            },
            {
              path: 'leaveDetail',
              name: '请假详情概览',
              component: leaveDetail
            },
            {
              path: 'leaveHandle',
              name: '请假处理概览',
              component: leaveHandle
            },
          ]
      },

      {
        path: 'schedulingstart',
        name: '开始排课',
        component: schedulingStart,
        meta: { api: "https://www.yuque.com/u314548/ua2qh6/pqwqit" }
      },

      // 学员管理
      {
        path: 'user',
        name: '学员管理',
        component: SubDefaultContainer,
        redirect: 'user/dashboard',
        children: [
          {
            path: 'dashboard',
            name: '学员管理概览',
            component: user
          },
          {
            path: 'add',
            name: '增加学员',
            component: userAdd
          },
          {
            path: 'edit',
            name: '修改学员',
            component: userEdit
          },

          {
            path: 'classHoursDetail',
            name: '学时详情',
            component: userClassHoursDetail
          },
          // 请假审核
          {
            path: 'leave',
            name: '进行请假审核',
            component: leaveExamine,
          },
          {
            path: 'leaveDetail',
            name: '请假详情',
            component: leaveDetail
          },
          {
            path: 'leaveHandle',
            name: '请假处理',
            component: leaveHandle
          },

        ]
      },

      // 学时信息
      {
        path: 'export',
        name: '报表管理',
        component: SubDefaultContainer,
        redirect: 'export/exportquick',
        children: [
          {
            path: 'exportquick',
            name: '常用导出',
            component: SubDefaultContainer,
            redirect: 'exportquick/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '导出概览',
                component: exportQuick
              }
            ]
          }, 
          {
            path: 'studyclassHours',
            name: '学时信息(学习班)',
            component: SubDefaultContainer,
            redirect: 'studyclassHours/dashboard',
            children: [
              {
                path: 'dashboard',
                name: '学时信息（学习班）概览',
                component: studyclassHours
              },
              {
                path: 'studyclassHoursDetail',
                name: '学时信息(学习班)学时详情',
                component: studyclassHoursDetail
              }
            ]
          }, 
          {
            path: 'schedulingHours',
            name: '学时信息（排课）',
            component: SubDefaultContainer,
            redirect: 'schedulingHours/dashboard',
            children: [
                {
                  path:'dashboard',
                  name: '学时信息（排课）概览',
                  component: SchedulingHours
                }
            ]
          },
          
          
          
          {
            path: 'classPlanDetail',
            name: '排课信息详情',
            component: classPlanDetail
          },
          {
            path: 'userclassHours',
            name: '学员',
            component: SubDefaultContainer,
            redirect: 'userclassHours/dashboard',
            children:[
              {
                path: 'dashboard',
                name: '学员概览',
                component: userClassHours
              }
            ]
          },
          {
            path: 'classunit',
            name: '学时（单位）',
            component: SubDefaultContainer,
            redirect: 'classunit/dashboard',
            children:[
              {
                path: 'dashboard',
                name: '学时（单位）概览',
                component: ExportClassunit
              },
              {
                path: 'detail',
                name: '学时（单位）详细',
                component: ExportClassunitDetail
              }
            ]
          },
          {
            path: 'partyorg',
            name: '学时（党组织）',
            component: SubDefaultContainer,
            redirect: 'partyorg/dashboard',
            children:[
              {
                path: 'dashboard',
                name: '学时（党组织）概览',
                component: ExportPartyOrg
              },
              {
                path: 'detail',
                name: '学时（党组织）详细',
                component: ExportPartyorgDetail
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/pages',
    redirect: 'pages/404',
    name: 'Pages',
    component: {
      render(c: any) {
        return c('router-view')
      }
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: login
      },
      {
        path: 'loginEntrance',
        name: 'LoginEntrance',
        component: loginEntrance
      },
      {
        path: 'reset',
        name: 'Reset',
        component: reset
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: "",
  routes
})

export default router
